import { breakpoints } from '../constants/breakpoints.json.js';

/**
 * Creates a simple reusable media query based on size from breakpoints
 *
 * @param {('xs'|'sm'|'md'|'lg'|'xl')} size - The size of the breakpoint as specified by DLS
 * @param {boolean} [down] - If true, will use max-width and subtract 1 px from breakpoint
 * @returns {string} - The constructed media query
 */

var mediaQuery = function mediaQuery(size, down) {
  if (!breakpoints[size]) {
    return '';
  }

  var breakpointParsed = breakpoints[size].replace('px', '');
  var breakPoint = down ? breakpointParsed - 1 : breakpointParsed;
  var condition = down ? 'max-width' : 'min-width';
  return "@media (".concat(condition, ": ").concat(breakPoint, "px)");
};

export default mediaQuery;
